import _range from 'lodash-es/range';
import { NotationSystem } from '@teetsh/app/src/types/notationSystem';

import { getNotationsHelperAttributes } from '@teetsh/app/src/containers/CarnetsDeNotes/Evaluations/utils/getNotationsHelperAttributes';
const percentageValues = _range(100, 1).map(i => ({
  id: i.toString(),
  label: i.toString(),
  value: i,
}));

const NoteSur20Notation: NotationSystem = getNotationsHelperAttributes({
  id: '20',
  type: 'numerical',
  name: 'Notes de 0 à 20',
  minValue: 0,
  maxValue: 20,
  noMaxValue: false,
  values: percentageValues,
});


const NoteSur10Notation: NotationSystem = getNotationsHelperAttributes({
  id: '10',
  type: 'numerical',
  name: 'Notes de 0 à 10',
  minValue: 0,
  maxValue: 10,
  noMaxValue: false,
  values: percentageValues,
});

export const PourcentagesNotation: NotationSystem =
  getNotationsHelperAttributes({
    id: '%',
    type: 'numerical',
    name: 'Notes de 0 à 100',
    minValue: 0,
    maxValue: 100,
    noMaxValue: false,
    values: percentageValues,
  });

export const notationSystems = {
  [PourcentagesNotation.id]: PourcentagesNotation,
  [NoteSur20Notation.id]: NoteSur20Notation,
  [NoteSur10Notation.id]: NoteSur10Notation,
};
